// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { DataTransferAddendumPage } from '../pages/DataTransferAddendumPage/DataTransferAddendumPage';

export const Route = createFileRoute('/data-transfer-addendum')({
  component: DataTransferAddendumPage,
});
